// extracted by mini-css-extract-plugin
export var card = "_mj-5";
export var cardSelected = "_mj-4";
export var image = "_mj-3";
export var modal = "_mj-0";
export var modalContent = "_mj-1";
export var table = "_mj-2";